import React from 'react'
import styled from 'styled-components'
import { inboxSkeletonSurface } from '../skeleton/inboxSkeletonStyles'

const ContactDetailsPreloader: React.FC = () => (
    <Container>
        <Photo />
        <Info>
            <Line width={140} />
            <Line width={100} />
        </Info>
    </Container>
)

const Container = styled.div`
    display: flex;
    align-items: center;
    padding: 13px 16px;
    background-color: ${props => props.theme.secondaryColor || '#fff'};
    border-radius: 4px;
    margin-bottom: 2px;
`
const Photo = styled.div`
    width: 40px;
    height: 40px;
    border-radius: 50%;
    ${inboxSkeletonSurface}
    flex-shrink: 0;
    margin-right: 12px;
`
const Info = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`
const Line = styled.div<{ width: number }>`
    height: 14px;
    width: ${props => props.width}px;
    ${inboxSkeletonSurface}
    border-radius: 4px;
`

export default ContactDetailsPreloader
